<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center> {{$route.name}}</b-navbar-brand>

          <b-button v-if="
              $sessionsStorage.get('designation') == 'Admin' &&
              $sessionsStorage.get('nameUser') == 'Bhavneesh'
            " :disabled="ExcelBtnName != 'Export As Excel' ? true : false" class="ml-3"
            @click="getReports('Vendor_GST_List', 'Export As Excel')" size="sm" variant="outline-info">{{ ExcelBtnName
            }}
            <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="align-items-end">
                <b-col md="12">
                  <h5>
                    {{ VendorGSTMaster.vendor_add_id ? "Update " : "Add " }}
                    {{ VendorGSTMaster.vendor_add_LglNm }} Vendor Details
                  </h5>
                </b-col>
                <b-col md="4">
                  <label>
                    Vendor Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" id="vendor_add_LglNm" name="vendor_add_LglNm"
                    v-model="VendorGSTMaster.vendor_add_LglNm" placeholder="State Name"></b-form-input>
                  <!-- :disabled="
                      VendorGSTMaster.vendor_gst_type != 1 &&
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                        ? false
                        : VendorGSTMaster.vendor_add_id
                        ? true
                        : false
                    " -->
                  <span class="error" v-if="!VendorGSTMaster.vendor_add_LglNm">
                    {{ errorList.vendor_add_LglNm }}
                  </span>
                </b-col>
                <b-col md="4">
                  <label>
                    Vendor Add
                    <span class="error">*</span>
                  </label>
                  <b-textarea size="sm" id="vendor_add_Addr1" name="vendor_add_Addr1"
                    v-model="VendorGSTMaster.vendor_add_Addr1" placeholder="Please Enter Address"></b-textarea>
                  <!-- :disabled="
                      VendorGSTMaster.vendor_gst_type != 1 && 
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                        ? false
                        : VendorGSTMaster.vendor_add_id
                        ? true
                        : false
                    " -->
                  <span class="error" v-if="!VendorGSTMaster.vendor_add_Addr1">
                    {{ errorList.vendor_add_Addr1 }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    State
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" id="vendor_add_Loc" name="vendor_add_Loc"
                    v-model="VendorGSTMaster.vendor_add_Loc" placeholder="Please Enter State"></b-form-input>
                  <!-- :disabled="
                      VendorGSTMaster.vendor_gst_type != 1 && 
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                        ? false
                        : VendorGSTMaster.vendor_add_id
                        ? true
                        : false
                    " -->
                  <span class="error" v-if="!VendorGSTMaster.vendor_add_Loc">
                    {{ errorList.vendor_add_Loc }}
                  </span>
                </b-col>
                <b-col md="1">
                  <label>
                    State Code
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" id="vendor_add_Stcd" name="vendor_add_Stcd"
                    v-model="VendorGSTMaster.vendor_add_Stcd" placeholder="State Code"></b-form-input>
                  <!-- :disabled="
                      VendorGSTMaster.vendor_gst_type != 1 && 
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                        ? false
                        : VendorGSTMaster.vendor_add_id
                        ? true
                        : false
                    " -->
                  <span class="error" v-if="!VendorGSTMaster.vendor_add_Stcd">
                    {{ errorList.vendor_add_Stcd }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    GST No
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" id="vendor_add_Gstin" name="vendor_add_Gstin"
                    v-model="VendorGSTMaster.vendor_add_Gstin" placeholder="Please Enter GST NO"></b-form-input>
                  <!-- :disabled="
                      VendorGSTMaster.vendor_gst_type != 1 &&
                      $sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh'
                        ? false
                        : VendorGSTMaster.vendor_add_id
                        ? true
                        : false
                    " -->
                  <span class="error" v-if="!VendorGSTMaster.vendor_add_Gstin">
                    {{ errorList.vendor_add_Gstin }}
                  </span>
                </b-col>



                <b-col md="3" v-if="(VendorGSTMaster.vendor_gst_type == 2 && 
                  VendorGSTMaster.vendor_add_Gstin!=undefined && 
                  VendorGSTMaster.vendor_add_Gstin!=null && 
                  VendorGSTMaster.vendor_add_Gstin!='') || VendorGSTMaster.vendor_gst_type == 3">
                  <label>
                    Status :
                    <span class="error">*</span>
                  </label>
                  <md-switch :id="'approval' + VendorGSTMaster.vendor_add_is_active" name="approval" class="md-primary"
                    :value="VendorGSTMaster.vendor_add_is_active == true ? true : false"
                    @change="activateVendorGSTMaster()">
                    <h6>
                      <b-badge :variant="
                          VendorGSTMaster.vendor_add_is_active == 1 ? 'success' : 'danger'
                        ">{{
                        VendorGSTMaster.vendor_add_is_active == 1
                        ? "Active"
                        : "In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addVendorGSTMaster" class="mt-2"
                      id="addButtonLoader">
                      {{ VendorGSTMaster.vendor_add_id ? "Update" : "Save" }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Vendor GST Master and Code" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-button variant="outline-primary" v-if="$route.path!='/povendorgstMaster'"
                    @click="addEditCardFunc()" size="sm">Add</b-button>
                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="MasterVendorList" :fields="fields" :current-page="currentPage"
                  :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection" @filtered="onFiltered" responsive primary-key="vendor_add_id"
                  class="position-relative">
                  <template slot="vendor_add_id" slot-scope="row0">
                    <span>
                      {{ row0.index + 1 + (currentPage - 1) * perPage }}
                    </span>
                  </template>
                  <template slot="vendor_add_LglNm" slot-scope="row1">
                    <span>{{ row1.item.vendor_add_LglNm }}</span>
                  </template>
                  <template slot="vendor_add_Addr1" slot-scope="row1">
                    <span>{{ row1.item.vendor_add_Addr1 }}</span>
                  </template>
                  <template slot="vendor_add_Loc" slot-scope="row1">
                    <span>{{ row1.item.vendor_add_Loc }}</span>
                  </template>
                  <template slot="vendor_add_Stcd" slot-scope="row1">
                    <span>{{ row1.item.vendor_add_Stcd }}</span>
                  </template>
                  <template slot="vendor_add_Gstin" slot-scope="row2">
                    <span>{{ row2.item.vendor_add_Gstin }}</span>
                  </template>
                  <template slot="vendor_add_is_active" slot-scope="row3">
                    <div :id="'row' + row3.item.vendor_add_id">
                      <md-switch
                        v-if=" (row3.item.vendor_gst_type == 2 && row3.item.vendor_add_Gstin) || row3.item.vendor_gst_type != 1"
                        :id="'approval' + row3.item.vendor_add_id" name="approval" class="md-primary"
                        :value="row3.item.vendor_add_is_active == 1 ? true : false" @change="activateVendor(row3.item)">
                      </md-switch>

                      <b-badge :variant="
                          row3.item.vendor_add_is_active == 1 ? 'success' : 'danger'
                        ">{{
                        row3.item.vendor_add_is_active == 1 ? "Active" : "In-Active"
                        }}</b-badge>
                    </div>
                  </template>
                  <template slot="creationTime" slot-scope="row3">{{
                    row3.item.creationTime
                    }}</template>

                  <template slot="action" slot-scope="row2">
                    <b-button variant="outline-primary" @click="editVendorLocation(row2.item)" id="addButtonLoader"
                      size="sm">Update</b-button>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import ClientUserService from "../../services/ClientUserService.js";
import CustomLoader from "../common/customLoader.vue";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/vendorMaster");
      if (globalPermissionStatus("Vendor GST Master") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("Vendor GST Master")
        );
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
      this.getVendorGSTMaster("Normal");
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      vendor_id: this.$sessionsStorage.get("tallyVendorId"),
      addEditCard: false,
      isLoading: false,
      fields: [
        {
          key: "vendor_add_id",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vendor_add_LglNm",
          label: "Vendor Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vendor_add_Addr1",
          label: "Address",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vendor_add_Loc",
          label: "State",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vendor_add_Stcd",
          label: "State Code",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "vendor_add_Gstin",
          label: "GST",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "vendor_add_is_active",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "creationTime",
          label: "Date",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      ExcelBtnName: "Export As Excel",
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      adminToggle: this.$sessionsStorage.get("designation"),
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      Filter: { statusFilter: "3", vendor_id: this.vendor_id ? this.vendor_id : null },
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      VendorGSTMaster: {
        vendor_add_id: "",
        vendor_add_LglNm: "",
        vendor_add_Addr1: "",
        vendor_add_Loc: "",
        vendor_add_Stcd: "",
        vendor_add_Gstin: "",
        vendor_add_is_active: true,
        TypeofAdd: "Vendor GST Master Add",
      },
      VendorGSTMasterError: [
        "Please Enter Vendor Name",
        "Please Enter Vendor Address",
        "Please Enter State Name",
        // "Please Select State Code",
        // "Please Enter GST No",
      ],
      errorList: {
        vendor_add_LglNm: "",
        vendor_add_Addr1: "",
        vendor_add_Loc: "",
        // vendor_add_Stcd: "",
        // vendor_add_Gstin: "",
      },

      MasterVendorList: [],
      validate: true,
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    activateVendor(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.vendor_add_is_active = this.itemObj.vendor_add_is_active == 1 ? 0 : 1;
      let paylod = {
        tableName: "master_tbe_vendorAddress",
        tableId: "vendor_add_id",
        tableIsActive: "vendor_add_is_active",
        value1: this.itemObj.vendor_add_is_active,
        tableVal: item.vendor_add_id,
        isMailSend:'No',
         manual:'No',
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {
          console.log("Catch on Vendor ACtive Error: ", error);
        });
    },
    clearErrVal() {
      this.VendorGSTMaster = {
        vendor_add_id: "",
        vendor_add_LglNm: "",
        vendor_add_Addr1: "",
        vendor_add_Loc: "",
        vendor_add_Stcd: "",
        vendor_add_Gstin: "",
        vendor_add_is_active: true,
        TypeofAdd: "Vendor GST Master Add",
      };
      this.errorList = {
        vendor_add_LglNm: "",
        vendor_add_Addr1: "",
        vendor_add_Loc: "",
        // vendor_add_Stcd: "",
        // vendor_add_Gstin: "",
      };
    },

    editVendorLocation(item) {
      this.clearErrVal();
      this.addEditCard = true;
      item.TypeofAdd = "Vendor GST Master Add";
      this.VendorGSTMaster = item;
      this.setFocus();
    },
    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
    },
    setFocus: function () {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    activateVendorGSTMaster() {
      if (
        this.VendorGSTMaster.vendor_add_is_active == 1 ||
        this.VendorGSTMaster.vendor_add_is_active == true
      ) {
        this.VendorGSTMaster.vendor_add_is_active = false;
      } else if (
        this.VendorGSTMaster.vendor_add_is_active == 0 ||
        this.VendorGSTMaster.vendor_add_is_active == false
      ) {
        this.VendorGSTMaster.vendor_add_is_active = true;
      }
    },
    goBack() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getVendorGSTMaster("Normal");
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.Filter = {
        statusFilter: "3",
        vendor_id: this.vendor_id ? this.vendor_id : null,
      };
      this.getVendorGSTMaster("Normal");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    validateVendorGSTMaster() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.VendorGSTMaster[x] == "" ||
          this.VendorGSTMaster[x] == undefined ||
          this.VendorGSTMaster[x] == null
        ) {
          this.errorList[x] = this.VendorGSTMasterError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },

    addVendorGSTMaster() {
      this.validateVendorGSTMaster();
      console.log("this.validate=>",this.validate)
      this.VendorGSTMaster.TypeofAdd = "Vendor GST Master Add";
      if (this.validate == false) return false;
      this.isLoading = true;

      let payload = {
        itemCode: "add_Vendor_GST_Details",
        VendorGSTMaster: this.VendorGSTMaster,
      };
      payload = JSON.stringify(payload);
      if (this.validate != false) {
        CommonService.getAllExpenseList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.vendor_add_id != "" && data.vendor_add_id != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.addEditCardFunc();
              this.getVendorGSTMaster("Normal");
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getVendorGSTMaster("Excell");
    },
    getVendorGSTMaster(type) {
      this.isLoading = true;
      let payload = {
        itemCode: "All_Vendor_GST_List",
        Filter: { statusFilter: "3", vendor_id: this.vendor_id ? this.vendor_id : null },
        type: type ? type : "Normal",
        statusFilter:this.$route.path=='/povendorgstMaster'?'2':'1'
      };
      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excell") {
              this.ExcelBtnName = "Export As Excel";
              if (data.MasterVendorList.length > 0) {
                this.MasterVendorList = data.MasterVendorList;
                this.totalRows = data.MasterVendorList.length;
              }
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.MasterVendorList.length > 0) {
                this.MasterVendorList = data.MasterVendorList;
                this.totalRows = data.MasterVendorList.length;
                console.log(" getAllExpenseList response=>", data);
              }
            }
          } else {
            this.MasterVendorList = [];
          }
          this.isLoading = false;
          this.PaginationCount = this.pagination.perPage;
        })
        .catch((error) => {
          console.log("Catch on getAllExpenseList Error: ", error);
        });
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// vendorGstMaster.vue?0bd9828f